<script>
    import { t, updateLanguage } from '../i18n.js'
    import { createEventDispatcher } from 'svelte'
    import { isMobile, locale } from '../store/stores.js'

	const dispatch = createEventDispatcher()

    const langSelects = [
        {
            id: 'fi',
            title: 'nav.lang-fi',
            label: 'nav.lang-label-fi',
            value: 'fi',
            group: 'options',
            default: true
        },
        {
            id: 'en',
            title: 'nav.lang-en',
            label: 'nav.lang-label-en',
            value: 'en',
            group: 'options'
        }
    ]

    const click = (e) => {
        const { target: { value }} = e

        dispatch("locale", value);
        updateLanguage(value)
    }

</script>


<div
    role="radiogroup" 
    aria-labelledby="label-lang-select"
    id='group-lang-select'
    class="{$isMobile ? 'float-right mb-12' : ''} flex w-fit items-center after:block after:absolute after:left-[50%] after:top-1 after:bottom-1 after:w-[1px] after:bg-white relative inline-block">
    {#each langSelects as { value, title, id }}
        <input
            type="radio"
            id={id}
            bind:group={$locale}
            on:click={click}
            value={value}
            class="appearance-none" />
        <label for={id} class="uppercase cursor-pointer text-sm border border-white flex justify-center w-7 h-6 rounded-md last:ml-6 transition duration-150 hover:bg-primary-blue hover:border-primary-blue {value === $locale ? 'font-semibold text-light-navy bg-white hover:text-white' : 'text-white'}">
            {$t(title)}
        </label>
    {/each}
</div>